import { render, staticRenderFns } from "./VideoReactionMenu.vue?vue&type=template&id=cb501e96&scoped=true&"
import script from "./VideoReactionMenu.vue?vue&type=script&lang=ts&"
export * from "./VideoReactionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VideoReactionMenu.vue?vue&type=style&index=0&id=cb501e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb501e96",
  null
  
)

export default component.exports